import {TextMidd} from "@/components/ui/Text"
import type {AccountTabType} from "../../AccountSettingsModal"
import css from "./AccountSettingsNavigation.module.css"

interface AccountSettingsNavigationProps {
    options: { label: string; tab: AccountTabType }[]
    activeTab: AccountTabType
    onTabChange: (tab: AccountTabType) => void
}

const AccountSettingsNavigation = ({options, activeTab, onTabChange}: AccountSettingsNavigationProps) => {
    const getClassName = (tab: AccountTabType) =>
        [css.item, activeTab === tab ? css.active : ''].filter(Boolean).join(' ')

    return (
        <div className={css.container}>
            {options.map(({label, tab}) => (
                <div key={tab} className={getClassName(tab)} onClick={() => onTabChange(tab)}>
                    <TextMidd>{label}</TextMidd>
                </div>
            ))}
        </div>
    )
}

export default AccountSettingsNavigation
